import { Flex, FlexProps, theme, useColorMode } from '@bnb-chain/space';
import { useScroll } from 'ahooks';

import { LogoIcon } from '@/core/components/icons/Logo';
import { ConnectWalletButton } from '@/modules/wallet/components/ConnectWalletButton';

export function Header(props: FlexProps) {
  const { colorMode } = useColorMode();
  const scroll = useScroll(() => document);

  return (
    <Flex
      top={0}
      w={'100%'}
      position={'fixed'}
      as="header"
      h={'64px'}
      borderBottom={`1px solid ${theme.colors[colorMode].border['2']}`}
      alignItems="center"
      justifyContent="space-between"
      py={'12px'}
      px={{ base: '20px', md: '40px' }}
      bg={theme.colors[colorMode].layer[1].default}
      gap="16px"
      boxShadow={(scroll?.top || 0) > 5 ? '0px 4px 8px 0px rgba(0, 0, 0, 0.56)' : 'none'}
      {...props}
    >
      <LogoIcon w={{ base: '77px', md: '115px' }} flexShrink={0} />
      <ConnectWalletButton />
    </Flex>
  );
}
